import React, { useContext, useEffect, useState, Fragment } from "react";

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import departamentosIcon from "../assets/img/departamentos.svg";
import ConexContext from "../context/ConexContext";
import { useNavigate } from "react-router-dom";
import { formatFecha } from "./JS/formato";

import { ReactComponent as IconTrash } from "../assets/img/icon-trash.svg";
import { ReactComponent as IconEdit } from "../assets/img/icon-edit.svg";
import ModalGenericoUsuario from "./modales/ModalGenericoUsuario";

const Departamentos = () => {
	const { peticion, tipo_usuario } = useContext(ConexContext);
	const navigate = useNavigate();

	const [modalEliminar, setModalEliminar] = useState(false); //modal eliminar usuario
	const [datosArbol, setdatosArbol] = useState(null); //datos de los usuarios
	const [mensaje, setMensaje] = useState(null); //mensaje de error
	const [departamentoselect, setdepartamentoselect] = useState(null); //departamento sleccioando
	const [Borrado, setBorrado] = useState(false); //recargar datps cuando borro

	const [filtros, setFiltros] = useState({//filtros
		entidad: '',
		empresa: '',
		buscar: ''
	});
	const [entidades, setEntidades] = useState({}); //listado de entidades con las empresas

	/**
	 * Carga los datos de los departamentos
	 */
	useEffect(() => {
		const listado_depart = async () => {
			let arbol = await peticion(`/arbol_departamentos`, { method: "GET" });
			if (arbol?.estado ?? true) return;
			if (arbol?.res ?? false) {
				setdatosArbol(arbol["res"]);
				//obtener entidades y empresas para filtrar
				const entidadesObj = {};
				arbol["res"].forEach(usuario => {
					const entidadCod = usuario.cod_ent;
					const entidadNombre = usuario.nombre_ent;
					const empresaNombre = usuario.nombre_emp;

					if (!entidadesObj[entidadCod]) {
							entidadesObj[entidadCod] = {
									cod: entidadCod,
									nombre: entidadNombre,
									empresas: []
							};
					}
					if (!entidadesObj[entidadCod].empresas.includes(empresaNombre))
						entidadesObj[entidadCod].empresas.push(empresaNombre);
				});
				setEntidades(entidadesObj);
			}
		};

		if (
			tipo_usuario === "5" ||
			tipo_usuario === "2" ||
			tipo_usuario === "0" ||
			tipo_usuario === "3"
		)
			listado_depart();
	}, [tipo_usuario, peticion, Borrado]);

	/**
	 * Genera la tabla de departamentos
	 * @returns Tabla de departamentos
	 */
	const TablaDepartamentos = () => {
		let prevCodEmp = null;
		let prevCodEnt = null;
		let rows = [];
		let sections = [];
	
		datosArbol
			.filter(dpto => { //filtrar por entidad y empresa
				if (filtros.entidad !== '' && dpto.cod_ent !== filtros.entidad) return false;
				if (filtros.empresa !== '' && dpto.nombre_emp !== filtros.empresa) return false;
				return true;
			})	
			.forEach((departamento, index) => {
				const showHeader =
					departamento.cod_emp !== prevCodEmp ||
					departamento.cod_ent !== prevCodEnt;
				
				if (showHeader && rows.length > 0) {
					sections.push(<tbody key={`tbody-${prevCodEmp}-${prevCodEnt}`}>{rows}</tbody>);
					rows = [];
				}
		
				if (showHeader) {
					sections.push(
						<thead key={`thead-${index}`} className="col-xs-12 cont_cabeceratabla cabeceratabla inner-rows">
							<tr className="cabecera">
								<td colSpan="5">
									({departamento.nombre_ent}) Empresa '{departamento.nombre_emp}'
								</td>
								<td>Nombre de departamento</td>
								<td>Fecha de alta</td>
							</tr>
						</thead>
					);
				}
		
				rows.push(
					<tr key={`tr-${index}`}>
						<td className={`indent-${departamento.nivel}`}>
							<div className="indent-spacer">
								<div className="indent-curve"></div>
							</div>
							<div className="indent-content">
								{departamento.cod_dpto}
							</div>
						</td>
						<td>
							<div>{departamento.nombre_dpto}</div>
						</td>
						<td>
							<div>
								{formatFecha(departamento.fecha_alta_dpto.toString(), "ISO8601", "esp")}
							</div>
							<div className="icon-container">
								<div>
									<IconEdit
										alt="Editar"
										onClick={() => {
											navigate("/departamento/" + departamento.cod_dpto + "_" + departamento.cod_emp + "_" + departamento.cod_ent);
										}}
									/>
								</div>
								<div>
									<IconTrash
										alt="Eliminar"
										onClick={() => {
											setdepartamentoselect(departamento);
											setModalEliminar(true);
										}}
									/>
								</div>
							</div>
						</td>
					</tr>
				);
		
				prevCodEmp = departamento.cod_emp;
				prevCodEnt = departamento.cod_ent;
			});
	
		if (rows.length > 0) {
			sections.push(<tbody key={`tbody-final`}>{rows}</tbody>);
		}
		
		return (
			<table>
				{sections}
			</table>
		);
	};
	
	const eliminarDepart = async () => {
		if (departamentoselect) {
			const res = await peticion(`/eliminar_departamento`, {
				method: "POST",
				json: {
					departamento: departamentoselect.cod_dpto,
					empresa: departamentoselect.cod_emp,
					entidad: departamentoselect.cod_ent,
				},
			});
			if (res?.estado ?? true) return setMensaje("Se ha producido un error" + res.mensaje); //error
			if (res?.mensaje !== "OK" ?? false)
				return setMensaje(
					res?.mensaje ??
						"Error al eliminar el departamento " +
							departamentoselect.nombre_dpto +
							""
				); //errores
		}
		return 0;
	};

	return (
		<>
			<div className="col-xs-12 tabla" id="user-mng">
				<div className="section-header">
					<div className="img-container">
						<img src={departamentosIcon} alt=""></img>
					</div>
					<div>
						<h2>Gestión de departamentos</h2>
						<h6>
							<strong>Listado</strong>
						</h6>
					</div>
				</div>
				<main>
				<h3>Filtrar por:</h3>
					<div className="filtering__container">
						<div className="filtering">
							<select id="entidad" name="entidad"
								onChange={(e) => setFiltros({ ...filtros, entidad: e.target.value, empresa: ''})}
							>
								<option value="">Selecciona una entidad</option>
								{
									Object.keys(entidades).map((entidadCod, index) => (
										<option key={index} value={entidadCod}>{entidades[entidadCod].nombre}</option>
									))

								}
							</select>
						</div>
						<div className="filtering">
							<select id="tipo-usuario" name="tipo-usuario"
								onChange={(e) => setFiltros({ ...filtros, empresa: e.target.value })}
								disabled={filtros.entidad === ''}
							>
								<option value="">Selecciona una empresa</option>
								{
									Object.keys(entidades)
										.filter(entidadCod => entidades[entidadCod].cod === filtros.entidad)
										.map((entidadCod, index) => (
											entidades[entidadCod].empresas.map((empresa, index) => (
												<option key={index} value={empresa}>{empresa}</option>
											))
										))
								}
							</select>
						</div>
					</div>
					<div className="tabladatos">
						<div className="col-xs-12 cont_tabladatos">
							{!datosArbol ? (
								<h1 className="cargando">Cargando...</h1>
							) : (
								TablaDepartamentos()
							)}
						</div>
					</div>
					<div className="button-container">
						<button className="cta" onClick={() => navigate("/departamento/")}>
							Crear departamento
						</button>
					</div>
				</main>
			</div>
			{/*  */}
			<ModalGenericoUsuario
				texto1={
					"¿Quiere eliminar este departamento (" +
					departamentoselect?.nombre_dpto +
					")?"
				}
				texto2={"Departamento eliminado correctamente"}
				texto3={"Eliminar departamento"}
				texto4={mensaje}
				setMensaje={setMensaje}
				navegar={() => {
					navigate("/administracion/departamentos")
					setdatosArbol(null)
					setBorrado(!Borrado)
				}}
				show={modalEliminar}
				onHide={() => setModalEliminar(false)}
				func={eliminarDepart}
			/>
		</>
	);
};

export default Departamentos;
